import React from 'react';
import { nanoid } from 'nanoid';
import { ImageType, SandTableType, type ST } from '@types';
import Modal from '@components/Modal';
import Title from '@components/Title';
import Tip from '@components/Tip';
import Image from '@components/Image';
import Button from '@components/Button';
import { $curSandTableIdApi, $tourDataApi } from '@stores/dataStores';
import { selectLibSandTable } from '../../mediaLib';
import fetchSandTableMatrices from '../actions/fetchSandTableMatrices';

interface Props {
  onRequestClose: () => void;
}

function SandTableCreateModal({ onRequestClose }: Props) {
  const addSandTable = (data: ST) => {
    $tourDataApi.update((draft) => {
      if (!draft.sandBox) draft.sandBox = [];
      draft.sandBox.push(data);
    });
    $curSandTableIdApi.set(data.id);
  };

  const createMapTable = () => {
    onRequestClose();
    const id = `s_${nanoid()}`;
    addSandTable({
      id,
      type: SandTableType.map,
      name: '地图沙盘',
      layerType: 0,
      showCurrentSceneOnly: 0,
      initialView: { type: 0 },
      markers: [],
    });
  };

  const createImageTable = async () => {
    const { images, matrices } = await selectLibSandTable();
    if (images) {
      onRequestClose();
      const item = images[0];
      const id = `s_${nanoid()}`;
      addSandTable({
        id,
        type: SandTableType.image,
        name: item.name,
        mediaId: item.id,
        mediaUrl: item.url,
        showCompass: 0,
        showCurrentSceneOnly: 0,
        markers: [],
      });
    } else if (matrices) {
      onRequestClose();
      const item = matrices[0];
      const id = `s_${nanoid()}`;
      await fetchSandTableMatrices(item.id);
      addSandTable({
        id,
        type: SandTableType.matrix,
        name: item.name,
        data: item.id,
        showCompass: 0,
        showCurrentSceneOnly: 0,
        markers: [],
      });
    }
  };

  return (
    <Modal
      isOpen
      style={{ width: 800, height: 550 }}
      header={
        <div className="flex">
          <Title>选择沙盘类型</Title>
          <Tip className="ml-10 self-end text-orange">
            沙盘类型选择后不可修改
          </Tip>
        </div>
      }
      onRequestClose={onRequestClose}
    >
      <div className="flex justify-between pt-20">
        <div className="relative flex flex-col items-center">
          <Image
            src="/imgs/bg-map.4d8a6acb693551d9a5df2d330bd8741c.png"
            type={ImageType.sysMedia}
            style={{ width: 370, height: 430 }}
          />
          <div className="absolute top-105 flex flex-col items-center">
            <Image
              src="/imgs/bg-map-icon.79c659a3e3de1e928d56100e7814d01f.png"
              type={ImageType.sysMedia}
              style={{ width: 48, height: 48 }}
            />
            <div className="mt-10 text-xl">地图沙盘</div>
            <div className="mt-25">以高德地图作为沙盘基础，</div>
            <div>用于室外（景区/高校/城市等）的沙盘展示。</div>
          </div>
          <Button
            className="absolute bottom-30 w-130"
            size="xl"
            onClick={createMapTable}
          >
            创建沙盘
          </Button>
        </div>
        <div className="relative flex flex-col items-center">
          <Image
            src="/imgs/bg-st.f4ea77aa38254452b86512adb4144dc3.png"
            type={ImageType.sysMedia}
            style={{ width: 370, height: 430 }}
          />
          <div className="absolute top-105 flex flex-col items-center">
            <Image
              src="/imgs/bg-st-icon.b5bc9adb1914008e6cbd9cca7ad93f9e.png"
              type={ImageType.sysMedia}
              style={{ width: 48, height: 48 }}
            />
            <div className="mt-10 text-xl">图片沙盘</div>
            <div className="mt-25">选择一张自定义图片作为沙盘基础，</div>
            <div>用于：户型图/俯视图/平面图等沙盘展示。</div>
          </div>
          <Button
            className="absolute bottom-30 w-130"
            size="xl"
            onClick={createImageTable}
          >
            选择自定义图片
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default SandTableCreateModal;
